export const CloserCrossIcon = () => {
  return (
    <svg
      width='6'
      height='7'
      viewBox='0 0 6 7'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.5452 0.954779C5.46564 0.875246 5.35775 0.830566 5.24526 0.830566C5.13277 0.830566 5.02488 0.875246 4.94532 0.954779L2.99975 2.90035L1.05417 0.954779C0.974612 0.875246 0.866724 0.830566 0.75423 0.830566C0.641736 0.830566 0.533848 0.875246 0.454291 0.954779C0.374757 1.03434 0.330078 1.14222 0.330078 1.25472C0.330078 1.36721 0.374757 1.4751 0.454291 1.55466L2.39987 3.50023L0.454291 5.44581C0.374757 5.52537 0.330078 5.63325 0.330078 5.74575C0.330078 5.85824 0.374757 5.96613 0.454291 6.04569C0.533848 6.12522 0.641736 6.1699 0.75423 6.1699C0.866724 6.1699 0.974612 6.12522 1.05417 6.04569L2.99975 4.10011L4.94532 6.04569C5.02488 6.12522 5.13277 6.1699 5.24526 6.1699C5.35775 6.1699 5.46564 6.12522 5.5452 6.04569C5.62473 5.96613 5.66941 5.85824 5.66941 5.74575C5.66941 5.63325 5.62473 5.52537 5.5452 5.44581L3.59962 3.50023L5.5452 1.55466C5.62473 1.4751 5.66941 1.36721 5.66941 1.25472C5.66941 1.14222 5.62473 1.03434 5.5452 0.954779Z'
        fill='currentColor'
      />
    </svg>
  );
};
